import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { useCustomerType } from '../../../../modules/apis/student/products'
import { APP_SCREEN_NAME } from '../../../../modules/hooks/common/appRouterVars'
import useAppRouter, { sendRouterEvent } from '../../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_speaking, n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { timeDifference } from '../../../../modules/utils'
import { useConversationAIStack } from '../../../../pages/[lang]/webview/conversational-ai'

const RoleplayStopPopup = ({ thread, stopModal, setStopModal, minimumWord }) => {
  const { t } = useTranslation()
  const { data: customerType } = useCustomerType()
  const getFullUrl = useReturnFullUrl()
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop, push } = useConversationAIFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const diff = timeDifference(thread?.created_at)
  const requiresAttendanceVerification = customerType?.requiresAttendanceVerification

  const onClickExitThread = () => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopAudio' }))
    } catch (e) {
      console.log(e)
    }

    sendRouterEvent({
      nav: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
    })
    router.push(urls.webview.aiTutor.index(null, 1), {
      appScreenName: APP_SCREEN_NAME.AI_TUTOR_SCREEN,
      appSendData: { url: getFullUrl(urls.webview.aiTutor.index(null, 1)) },
    })
  }

  return (
    <DSModal id="conversationErrorModal" isOpen={stopModal} setIsOpen={setStopModal} size={'sm'} closeButton={false}>
      <DSModal.Title className="keep-all">
        {requiresAttendanceVerification ? t(n_ai_speaking.popup_exit1.title_b2b) : t(n_ai_speaking.popup_exit1.title)}
      </DSModal.Title>
      <DSModal.Content className="mb-[24px]">
        {requiresAttendanceVerification
          ? minimumWord
            ? t(n_ai_speaking.b2b_wordcount.popup_body2(minimumWord, diff.minutes))
            : t(n_ai_speaking.popup_exit1.body_b2b(diff.minutes))
          : t(n_ai_speaking.popup_exit1.body(diff.minutes))}
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        {/* 팝업만 끄기 */}
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.OUTLINE} onClick={() => setStopModal(false)}>
          <DSButton.Label>{t(n_ai_tutor.roleplay_popup.btn1)}</DSButton.Label>
        </DSButton>
        {/* 페이지 나가버리기 */}
        <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={() => onClickExitThread()}>
          <DSButton.Label>{t(n_ai_tutor.roleplay_popup.btn2)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default RoleplayStopPopup
